<script lang="ts" setup>
import type { SizeVariants } from '~kui/types/kui';
import type { RouteLocationRaw } from 'vue-router';

import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

interface Props {
  text: string;
  to: string | RouteLocationRaw;
  size?: Extract<SizeVariants, 'sm' | 'md' | 'lg' | 'xl'>;
  isExternal?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  isExternal: false,
});

const classList = computed(() => {
  return twMerge(
    cva('cursor-pointer', {
      variants: {
        size: {
          sm: 'text-sm',
          md: 'text-base',
          lg: 'text-lg',
          xl: 'text-xl',
        },
      },
    })({
      size: props.size,
    }),
  );
});

const targetValue = computed(() => (props.isExternal ? '_blank' : undefined));
</script>

<template>
  <NuxtLink
    :class="classList"
    :to="to"
    :external="isExternal"
    :target="targetValue"
  >
    {{ text }}
  </NuxtLink>
</template>
